import type { GenieKnowledgeEntry } from '../../types';

export const polyneuropathy: GenieKnowledgeEntry = {
  id: 'polyneuropathy',
  aliases: ['chronic_axonal_neuropathy', 'axonal_cold_temperature_corrected'],
  name: 'Polineuropatía',
  category: 'neuropatico',
  conversation: {
    headline:
      'Proceso neuropático simétrico longitud-dependiente. Clasifique axonal vs desmielinizante para guiar el diferencial etiológico.',
    edxHighlights: [
      'Patrón axonal: amplitudes ↓ con velocidades >75% LIN',
      'Patrón desmielinizante: VCM <70% LIN, bloqueos, dispersión — buscar CIDP',
      'Progresión típica: SNAP sural → peroneo superficial → CMAPs distales',
      'EMG: fibrilaciones distales + PUMs neurogénicos crónicos',
    ],
    pearls: [
      'SNAP sural normal con SNAPs de MS ausentes → ganglioneuropatía (no longitud-dependiente).',
      'En diabético con patrón desmielinizante, descartar CIDP sobreimpuesta.',
    ],
    differentials: [
      { name: 'Diabética', distinguishingHint: 'axonal simétrica distal; sural ↓ primero' },
      { name: 'CIDP', distinguishingHint: 'desmielinizante, tratable, curso crónico progresivo' },
      { name: 'Fibra fina', distinguishingHint: 'NCS normales con dolor quemante severo' },
    ],
    nextSteps: [
      'Laboratorio: glucosa, B12, TSH, proteinograma',
      'Si desmielinizante: descartar CIDP antes de etiquetar como idiopática',
    ],
  },
  orientationHints: {
    temporalFit: ['chronic'],
    whenToSuspect: 'Síntomas sensitivos/motores simétricos distales tipo guante-calcetín',
  },
};
